import API from "../helpers/api";
import {TSubType} from "../helpers/types";

export const getAllSubTypes = () => API.get('/subtypes').then((response:any): TSubType[] => response.data.data)
